// ── SVG CAR ───────────────────────────────────────────────────────────────────
import * as React from "react";
import {BUILD, ON_LOT} from "../../stores/listingsStore";
import {AsyncImage} from "../../components/AsyncImage";
import {useModalsStore} from "../../stores/modalsStore";
import {ListingDetailModal} from "./ListingDetail/ListingDetailModal";
import {useListingsSelection} from "../../contexts/ListingsSelectionContext";
import {useSelectListing} from "./useSelectListing";
import {SaveDealershipButton} from "./SaveDealershipButton";

const CarSVG = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="120" height="60" viewBox="0 0 120 60" fill="none">
        <rect x="10" y="28" width="100" height="22" rx="4" fill="#aaa"/>
        <path d="M25 28 L35 12 L85 12 L95 28Z" fill="#aaa"/>
        <circle cx="30" cy="52" r="8" fill="#666"/>
        <circle cx="30" cy="52" r="4" fill="#999"/>
        <circle cx="90" cy="52" r="8" fill="#666"/>
        <circle cx="90" cy="52" r="4" fill="#999"/>
        <rect x="38" y="15" width="44" height="12" rx="2" fill="#ccc" opacity="0.5"/>
    </svg>
);




export function VehicleCard({vehicle}) {
    const openModal = useModalsStore((state) => state.openModal)
    const selection = useListingsSelection()
    const {selecting, selectListing} = useSelectListing()

    const openDetails = () => {
        openModal({
            element: ListingDetailModal,
            id: "ListingDetailModal",
            props: {
                listingId: vehicle.id,
                // The modals store renders ListingDetailModal at the HomePage
                // level — a sibling of ListingsPageModal / outside the calc
                // drawer, so it can't see our ListingsSelectionContext. Hand the
                // callback down explicitly, otherwise Details' "Select Vehicle"
                // would fall through to the standalone new-tab flow on a
                // DealPage or in the calculator drawer.
                onSelectListing: selection?.onSelectListing,
            },
        })
    }

    const selectVehicle = (e) => selectListing(vehicle, {event: e})

    // Year sits on its own gray line above the "Make Model" title. The subtitle
    // is "Trim · Version" — the same line the Listing Details modal shows under
    // its title (ListingDetail.jsx). filter(Boolean) drops any missing field, so
    // a listing without a version degrades to just the trim (and an entirely
    // empty subtitle collapses to '') instead of rendering "undefined" or a
    // stray separator.
    const name     = [vehicle.make, vehicle.model].filter(Boolean).join(' ')
    const subtitle = [vehicle.trim, vehicle.version].filter(Boolean).join(' · ')

    return (
        <div className="vehicle-card" onClick={openDetails} style={{cursor: 'pointer'}}>
            <div className="card-image">
                <AsyncImage src={vehicle.image_url} alt={<CarSVG/>} width={"100%"} />
                <span className={`card-badge ${
                    vehicle.availability === ON_LOT ? "badge-lot"
                        : vehicle.availability === BUILD ? "badge-build"
                            : "badge-transit"
                }`}>
                  {vehicle.availability}
                </span>
            </div>
            <div className="card-body">
                <div className="card-year">{vehicle.year}</div>
                <div className="card-name">{name}</div>
                <div className="card-trim">{subtitle}</div>
                <div className="card-meta">
                    <div className="card-vin">VIN: {vehicle.vin}</div>
                    <div className="card-dealer">
                        <span className="card-dealer-name">🏪 {vehicle.dealership.name}</span>
                        <SaveDealershipButton dealership={vehicle.dealership} size={18}/>
                    </div>
                </div>
                <div className="card-footer">
                    {
                        vehicle.msrp &&
                        <div className="card-price">
                            {vehicle.msrp.toDollarFormat({decimalScale: 0})}
                            <span>MSRP</span>
                        </div>
                    }
                    <button
                        className="card-calc-btn"
                        onClick={selectVehicle}
                        disabled={selecting}
                    >
                        {selecting ? 'Selecting…' : 'Select'}
                    </button>
                </div>
            </div>
        </div>
    );
}
